module.exports = __webpack_public_path__ + "static/media/Salemaxlogo.18c98b7a.png";